import { message } from 'antd';
import { approveSubmission, getVMSApprove } from '../../../../services/popupApi';

export const api = {
  submit: async (values, context) => {
    const submissionId = context.selectedIds[0];
    // Primary write — the native, schema-free gateway approve. Once this
    // resolves the submission IS approved; nothing after may turn that into a
    // failure toast.
    await approveSubmission(submissionId, {
      candidateProposedRate: values.candidateProposedRate,
      candidateProposedRateCurrency: values.candidateProposedRateCurrency,
      candidateProposedRateUnit: values.candidateProposedRateUnit,
      submitVia: values.submitVia,
    });

    if (values.submitVia === 'VMS') {
      // VMS notification is a best-effort SIDE EFFECT that proxies to the legacy
      // submissions service — which 500s on rate-history arrays. Its failure
      // must NOT report the (already committed) approval as failed, which was
      // the "shows error even though it worked" bug. Swallow + warn instead of
      // rethrowing so the popup shows success.
      try {
        await getVMSApprove(submissionId);
      } catch {
        message.warning('Approved. VMS notification could not be sent — use Send Mail to notify the client.');
      }
    } else {
      message.info('Approved — use Send Mail to notify the client.');
    }
  },
};
